// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 32px;
  align-items: start;
}

/* Stepper */
.stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: 28px;
}

.step {
  display: flex;
  align-items: center;
  gap: 0;
}

.step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  border: 2px solid rgba(200,134,10,0.25);
  color: var(--text-light);
  background: var(--white);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.step.active .step-circle {
  background: linear-gradient(135deg, var(--gold), var(--orange));
  border-color: transparent;
  color: var(--white);
  box-shadow: 0 4px 12px rgba(200,134,10,0.35);
}

.step.done .step-circle {
  background: var(--green);
  border-color: transparent;
  color: var(--white);
}

.step-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-light);
  text-align: center;
  margin: 0 6px;
  white-space: nowrap;
}

.step.active .step-label { color: var(--gold-dark); }
.step.done .step-label { color: var(--green); }

.step-line {
  width: 40px;
  height: 2px;
  background: rgba(200,134,10,0.2);
  flex-shrink: 0;
}

/* Form */
.register-form {
  padding: 36px;
}

.form-step h2 {
  font-size: 1.4rem;
  margin-bottom: 24px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.field-group label {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--gold-dark);
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-input {
  padding: 12px 16px;
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: var(--text-dark);
  background: var(--cream);
  outline: none;
  transition: border-color 0.2s ease;
  width: 100%;
}

.form-input:focus {
  border-color: var(--gold);
}

textarea.form-input {
  resize: vertical;
  min-height: 90px;
}

select.form-input {
  cursor: pointer;
}

.activities-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.activity-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-mid);
  transition: all 0.2s ease;
}

.activity-check input {
  width: 15px;
  height: 15px;
  accent-color: var(--gold);
  cursor: pointer;
}

.activity-check.checked {
  border-color: var(--gold);
  background: rgba(200,134,10,0.08);
  color: var(--gold-dark);
  font-weight: 500;
}

.step-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid rgba(200,134,10,0.1);
}

/* Review */
.review-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 24px;
  background: rgba(200,134,10,0.04);
  border: 1px solid rgba(200,134,10,0.12);
  border-radius: 12px;
  padding: 20px;
}

.review-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.review-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.review-value {
  font-size: 0.9rem;
  color: var(--text-dark);
  font-weight: 500;
}

.agree-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-mid);
  line-height: 1.6;
  margin-bottom: 8px;
}

.agree-check input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold);
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 3px;
}

/* Sidebar */
.register-sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: sticky;
  top: 90px;
}

.benefits-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.benefits-list li,
.register-note ul li {
  font-size: 0.88rem;
  color: var(--text-mid);
}

.register-note ul {
  list-style: disc;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.benefits-card h3,
.register-note h3 {
  font-size: 1rem;
  margin-bottom: 14px;
}

/* Success */
.success-card {
  text-align: center;
  padding: 48px 40px;
  max-width: 560px;
  margin: 0 auto;
}

.success-card h2 {
  font-size: 1.8rem;
  margin: 16px 0 12px;
}

.success-card p {
  color: var(--text-mid);
  line-height: 1.8;
}

@media (max-width: 900px) {
  .register-layout {
    grid-template-columns: 1fr;
  }
  .register-sidebar { position: static; }
  .field-row { grid-template-columns: 1fr; }
}

@media (max-width: 560px) {
  .stepper { gap: 4px; }
  .step-line { width: 20px; }
  .step-label { display: none; }
  .register-form { padding: 24px 20px; }
  .activities-grid { grid-template-columns: 1fr; }
  .review-grid { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Register.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;EACxB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B,uBAAuB,EAAE;AACpD,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA,oBAAoB,gBAAgB,EAAE;EACtC,aAAa,0BAA0B,EAAE;AAC3C;;AAEA;EACE,WAAW,QAAQ,EAAE;EACrB,aAAa,WAAW,EAAE;EAC1B,cAAc,aAAa,EAAE;EAC7B,iBAAiB,kBAAkB,EAAE;EACrC,mBAAmB,0BAA0B,EAAE;EAC/C,eAAe,0BAA0B,EAAE;AAC7C","sourcesContent":[".register-layout {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 32px;\n  align-items: start;\n}\n\n/* Stepper */\n.stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  margin-bottom: 28px;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.step-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: 700;\n  border: 2px solid rgba(200,134,10,0.25);\n  color: var(--text-light);\n  background: var(--white);\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.step.active .step-circle {\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  border-color: transparent;\n  color: var(--white);\n  box-shadow: 0 4px 12px rgba(200,134,10,0.35);\n}\n\n.step.done .step-circle {\n  background: var(--green);\n  border-color: transparent;\n  color: var(--white);\n}\n\n.step-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-light);\n  text-align: center;\n  margin: 0 6px;\n  white-space: nowrap;\n}\n\n.step.active .step-label { color: var(--gold-dark); }\n.step.done .step-label { color: var(--green); }\n\n.step-line {\n  width: 40px;\n  height: 2px;\n  background: rgba(200,134,10,0.2);\n  flex-shrink: 0;\n}\n\n/* Form */\n.register-form {\n  padding: 36px;\n}\n\n.form-step h2 {\n  font-size: 1.4rem;\n  margin-bottom: 24px;\n}\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.field-group label {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--gold-dark);\n}\n\n.field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  background: var(--cream);\n  outline: none;\n  transition: border-color 0.2s ease;\n  width: 100%;\n}\n\n.form-input:focus {\n  border-color: var(--gold);\n}\n\ntextarea.form-input {\n  resize: vertical;\n  min-height: 90px;\n}\n\nselect.form-input {\n  cursor: pointer;\n}\n\n.activities-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.activity-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  transition: all 0.2s ease;\n}\n\n.activity-check input {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--gold);\n  cursor: pointer;\n}\n\n.activity-check.checked {\n  border-color: var(--gold);\n  background: rgba(200,134,10,0.08);\n  color: var(--gold-dark);\n  font-weight: 500;\n}\n\n.step-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 28px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(200,134,10,0.1);\n}\n\n/* Review */\n.review-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 24px;\n  background: rgba(200,134,10,0.04);\n  border: 1px solid rgba(200,134,10,0.12);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.review-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.review-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.review-value {\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n.agree-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  line-height: 1.6;\n  margin-bottom: 8px;\n}\n\n.agree-check input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--gold);\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n\n/* Sidebar */\n.register-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  position: sticky;\n  top: 90px;\n}\n\n.benefits-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.benefits-list li,\n.register-note ul li {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n}\n\n.register-note ul {\n  list-style: disc;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.benefits-card h3,\n.register-note h3 {\n  font-size: 1rem;\n  margin-bottom: 14px;\n}\n\n/* Success */\n.success-card {\n  text-align: center;\n  padding: 48px 40px;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.success-card h2 {\n  font-size: 1.8rem;\n  margin: 16px 0 12px;\n}\n\n.success-card p {\n  color: var(--text-mid);\n  line-height: 1.8;\n}\n\n@media (max-width: 900px) {\n  .register-layout {\n    grid-template-columns: 1fr;\n  }\n  .register-sidebar { position: static; }\n  .field-row { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 560px) {\n  .stepper { gap: 4px; }\n  .step-line { width: 20px; }\n  .step-label { display: none; }\n  .register-form { padding: 24px 20px; }\n  .activities-grid { grid-template-columns: 1fr; }\n  .review-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
